@if (displayBreadcrumbs().length > 1) {
  <nav class="breadcrumb" aria-label="Ruta de navegación">
    <ol class="breadcrumb__list">
      @for (crumb of displayBreadcrumbs(); track crumb.url; let last = $last) {
        @if (!last) {
          <li class="breadcrumb__item">
            <a class="breadcrumb__link" [routerLink]="crumb.url">{{ crumb.label }}</a>
            <mat-icon class="breadcrumb__separator" aria-hidden="true">chevron_right</mat-icon>
          </li>
        } @else {
          <li class="breadcrumb__item breadcrumb__item--active" aria-current="page">
            <span class="breadcrumb__current">{{ crumb.label }}</span>
          </li>
        }
      }
    </ol>
  </nav>
}
